import React from 'react';
import { colors } from 'Constants/Colors';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 *
 * @param {Object} props - Propiedades del componente.
 * @param {number} props.value - Valor del progreso.
 * @param {"determinate"|"indeterminate"} props.variant - Tipo de progreso.
 * @param {string|null|undefined} props.description - Descripción para la variante "indeterminate".
 */
function CircularProgressWithLabel(props) {
  const { value, variant = 'determinate', description } = props;

  // Si "variant" es "indeterminate" se muestra un CircularProgress con una descripción si se proporciona.
  if (variant === 'indeterminate') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
          margin: '1rem',
        }}
      >
        <CircularProgress variant="indeterminate" style={{ color: colors.GREEN_LEAF }} />
        {description && (
          <Typography variant="caption" color="text.secondary" textAlign="center">
            {description}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', margin: '1rem' }}>
      <CircularProgress variant="determinate" {...props} style={{ color: colors.GREEN_LEAF }} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;
